module.exports = __webpack_public_path__ + "img/yoseka_thumbnail.21de8a53.jpg";